import { useQuery } from '@tanstack/react-query'

import type { ChatFolder, Conversation } from '@shared/api/types'
import { api, unwrap } from '@shared/api/client'

export const CHAT_FOLDERS_KEY = ['chat-folders'] as const

export function useChatFolders() {
  return useQuery({
    queryKey: CHAT_FOLDERS_KEY,
    queryFn: async () => unwrap(await api.GET('/chat-folders')).items,
    refetchInterval: 20_000,
    refetchOnWindowFocus: true,
  })
}

/** Explicit membership adds a chat independently of type rules; exclusions win. */
export function inChatFolder(folder: ChatFolder, chat: Conversation): boolean {
  if (folder.exclude_ids.includes(chat.id)) return false
  if (chat.my.archived_at !== null) return false
  if (folder.unread_only && chat.unread_count === 0 && !chat.my.manual_unread) return false
  // Секретный чат (v1.13) для папок — личная переписка, как и обычный диалог пары.
  const kind = chat.kind === 'channel' ? chat.channel?.format : chat.kind === 'secret' ? 'direct' : chat.kind
  return (
    folder.include_ids.includes(chat.id) ||
    (folder.include_ids.length === 0 && folder.include_kinds.length === 0) ||
    (kind !== undefined && folder.include_kinds.includes(kind))
  )
}
